<template>
  <section class="price-section" id="price">
    <div class="wrapper">
      <div class="price-header">
        <h2 class="price-title title big weight-900">{{ $t("Our price") }}</h2>
        <p class="desc desc-20 weight-500">{{ $t("Island Packages") }}</p>
      </div>

      <div class="island-cards" v-if="islands">
        <div v-for="(item, i) in islands" :key="i" class="island-card-wrapper">
          <ProductCard :item="item" :currency="currency" :is-auth="isAuth" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProductCard from "./ProductCard.vue";

export default {
  name: "SectionFour",
  components: { ProductCard },
  props: {
    isAuth: Boolean,
    currency: String,
    islands: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.price-section {
  padding: 272px 16px 266px;
  position: relative;
  z-index: 1;
}
.price-header {
  text-align: center;
}
.title.price-title {
  line-height: 150%;
}
.price-title + .desc {
  color: #112a3a;
  line-height: 150%;
}
.island-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 55px 20px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 30px;
}

.island-card-wrapper {
  // width: 100%;
}

.option-card-wrapper {
  // width: 100%;
}

.options-section {
  margin-top: 122px;
  text-align: center;
}

.options-title {
  font-size: 64px;
  font-weight: 700;
  line-height: 81px;
  margin-bottom: 24px;
}

.options-subtitle {
  font-size: 32px;
  font-weight: 200;
  line-height: 40px;
  color: #a1d6f4;
  margin-bottom: 46px;
}

.options-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 46px 24px;
  justify-content: center;
}

@media (max-width: 1280px) {
  .island-cards {
    justify-content: center;
  }

  .price-title {
    font-size: 96px;
    line-height: 120px;
  }
}

@media (max-width: 768px) {
  .price-section {
    padding-top: 40px;
    padding-bottom: 80px;
  }
  .price-title {
    font-size: 64px;
    line-height: 80px;
  }

  .island-cards {
  }

  .island-card-wrapper {
    width: 100%;
    max-width: 393px;
    margin: 0 auto;
  }

  .options-grid {
    gap: 24px 16px;
  }
}
</style>
